// Hardcode the reCAPTCHA site key (must match the one in HTML)
const RECAPTCHA_SITE_KEY = '6LcNjgkrAAAAAL0CfBosNDhNz1e_ZLpn8P4T_l3k';

export interface RecaptchaResponse {
  token: string | null;
  context: {
    userAgent: string;
    action: string;
  };
}

declare global {
  interface Window {
    grecaptcha: {
      enterprise: {
        execute: (siteKey: string, options: { action: string }) => Promise<string>;
        ready: (callback: () => void) => void;
      };
    };
  }
}

/**
 * Get a reCAPTCHA Enterprise token and context for the specified action
 * @param action The action to get a token for (default: 'LOGIN')
 * @returns A Promise that resolves to an object containing the token and context information
 */
export const getRecaptchaToken = async (action = 'LOGIN'): Promise<RecaptchaResponse> => {
  const context = {
    userAgent: navigator.userAgent,
    action: action
    // Note: userIpAddress should be added on the server side
  };

  if (!window.grecaptcha || !window.grecaptcha.enterprise) {
    console.warn('reCAPTCHA Enterprise not loaded yet');
    return { token: null, context };
  }

  try {
    return new Promise((resolve) => {
      window.grecaptcha.enterprise.ready(() => {
        window.grecaptcha.enterprise
          .execute(RECAPTCHA_SITE_KEY, { action })
          .then((token) => {
            if (!token) {
              console.warn('Empty token received from reCAPTCHA');
            }
            resolve({ token, context });
          })
          .catch((error) => {
            console.error('reCAPTCHA Enterprise execution error:', error);
            resolve({ token: null, context });
          });
      });
    });
  } catch (error) {
    console.error('reCAPTCHA Enterprise error:', error);
    return { token: null, context };
  }
};
